import { FieldValuesResponse, LoadFieldValuesFromFileRequest } from '@cs-cms/types';
import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { useContext } from 'react';
import ServicesContext from '../../contexts/ServicesContext';
import { mutateFieldsKeys } from '../../mutationKeys/fields';

export function useLoadFieldValuesFromFile(): UseMutationResult<
  FieldValuesResponse,
  unknown,
  LoadFieldValuesFromFileRequest,
  unknown
> {
  const servicesCtx = useContext(ServicesContext);

  const loadFieldValues = (request: LoadFieldValuesFromFileRequest) => {
    if (servicesCtx?.fieldsService) {
      return servicesCtx.fieldsService.loadFieldValuesFromFile(request);
    }
    throw new Error('Services context not initialized');
  };

  return useMutation({
    mutationKey: mutateFieldsKeys.loadFieldValuesFromFile,
    mutationFn: (request: LoadFieldValuesFromFileRequest) => loadFieldValues(request)
  });
}
